import _ from 'lodash';

function splitter(inputString, l) {
  let str = inputString;
  const strs = [];
  while (str.length > l) {
    let pos = str.substring(0, l).lastIndexOf(' ');
    pos = pos <= 0 ? l : pos;
    strs.push(str.substring(0, pos));
    let i = str.indexOf(' ', pos) + 1;
    if (i < pos || i > pos + l) {
      i = pos;
    }
    str = str.substring(i);
  }
  strs.push(str);
  return strs;
}

const generateProductRemark = (remark) => {
  const splitWithLodash = _.split(remark, ' ');
  const newWordResult = _.map(splitWithLodash, (word) => {
    if (_.size(word) > 40) {
      const splitedRemark = splitter(word, 40);
      return _.join(splitedRemark, '\n');
    }

    return word;
  });

  return _.join(newWordResult, ' ');
};

export default generateProductRemark;
